import type { LayoutProperties, LayoutAlignEnum } from '@/types/BlockProperties'
import React from 'react'

type LayoutDirection = 'row' | 'column'

const alignMap: Record<LayoutAlignEnum, string> = {
	start: 'flex-start',
	center: 'center',
	end: 'flex-end',
	stretch: 'stretch',
	'space-between': 'space-between',
}

export function useLayoutStyles(
	layout: LayoutProperties | undefined,
	direction: LayoutDirection
): React.CSSProperties {
	const { gap, padding, alignMain, alignCross, wrap } = layout ?? {}

	return {
		display: 'flex',
		flexDirection: direction,
		gap: gap ?? 8,
		padding: padding ?? 0,
		justifyContent: alignMain ? alignMap[alignMain] : 'flex-start',
		alignItems: alignCross ? alignMap[alignCross] : 'stretch',
		flexWrap: wrap ? 'wrap' : 'nowrap',
	}
}
